module.exports = __webpack_public_path__ + "static/media/5.0ed9af16.mp3";